export type AppEnvironment = 'development' | 'staging' | 'production';

export interface AnalyticsConfig {
  /** GTM container ID — empty string when not set */
  gtmContainerId: string;
  // [plurallTracker] plurallFeedbackId: number;
  environment: AppEnvironment;
  isProduction: boolean;
  /** True when environment is staging or production */
  isTrackedEnvironment: boolean;
}

export function resolveEnvironment(mode: string): AppEnvironment {
  switch (mode) {
    case 'production':
      return 'production';
    case 'staging':
      return 'staging';
    case 'development':
    case 'local-dev':
    default:
      return 'development';
  }
}

// [plurallTracker] export function resolvePluralFeedbackId(raw: string | undefined): number { … }

const environment = resolveEnvironment(import.meta.env.MODE);

export const analyticsConfig: AnalyticsConfig = {
  gtmContainerId: import.meta.env.VITE_GTM_CONTAINER_ID ?? '',
  // [plurallTracker] plurallFeedbackId: resolvePluralFeedbackId(import.meta.env.VITE_PLURALL_FEEDBACK_ID),
  environment,
  isProduction: environment === 'production',
  isTrackedEnvironment: environment === 'staging' || environment === 'production',
};
